import FAQPanel from '#root/components/FAQPanel';
import type { FAQItem } from '#root/components/FAQPanel';
import { Timeline } from '#root/components/ui';

const offerFaq: FAQItem = {
  id: 'ofertar',
  question: '¿Cómo hago una oferta?',
  answer: (
    <>
      <Timeline
        variant="numbered"
        items={[
          'Selecciona un viaje: es obligatorio para ofertar',
          'Simula la compra: entra al link del producto, agrégalo al carrito y llega al checkout',
          'Coloca tu dirección en EE.UU. para que la tienda calcule el TAX (impuestos) y el SHIPPING (costo y tiempo de envío)',
          'Llena el Precio real (con TAX y shipping) y la Comisión, por la cantidad total, no unitario',
          'Indica tu fecha de entrega y, si puedes, más de un distrito',
          'Envía la oferta cuando se active el botón',
        ]}
      />
      <p>
        <small>
          Puedes proponer la comisión que creas adecuada. La fecha de entrega normalmente es 1 o 2
          días después de tu arribo a Perú. Ofrecer más de un distrito es más atractivo para el
          comprador.
        </small>
      </p>
    </>
  ),
};

const nationalFaq: FAQItem = {
  id: 'envio-nacional',
  question: '¿Qué es Envío Nacional?',
  answer: (
    <>
      <p>
        Es un pedido que el comprador quiere recibir por courier (OLVA).{' '}
        <strong>Tú no lo entregas al comprador</strong>: lo dejas en una oficina de{' '}
        <strong>MailBoxes ETC</strong> en Lima (Miraflores, San Isidro o Surco). 
        Ellos se encargan del resto.
      </p>
      <Timeline
        variant="numbered"
        items={[
          'Entrega el pedido en una oficina de MailBoxes ETC',
          'Toma fotos y envíalas por tu grupo de WhatsApp',
          'Sube 2 fotos del pedido para confirmar la entrega',
        ]}
      />
      <p>
        <small>
          Toca la etiqueta "Envío Nacional" de un pedido para ver las oficinas. Direcciones,
          horarios e indicaciones completas: en la etiqueta "Envío Nacional" de tu acuerdo.
        </small>
      </p>
    </>
  ),
};

const matchFaq: FAQItem = {
  id: 'match',
  question: '¿Qué son los Pedidos Match?',
  answer: (
    <>
      <p>
        Son pedidos que <strong>ya están pagados</strong>. Guvery cotizó el precio real y negoció la
        comisión; al asignártelo, se convierte directo en un Acuerdo pagado.
      </p>
      <p>Para ser elegible necesitas:</p>
      <ul>
        <li>Capacitación completa</li>
        <li>
          Un viaje activo con:
          <ul>
            <li>
              5 ofertas realizadas <strong>o</strong> 1 acuerdo comprado
            </li>
          </ul>
        </li>
      </ul>
    </>
  ),
};

const reserveFaq: FAQItem = {
  id: 'reservar',
  question: '¿Cómo reservo un Pedido Match?',
  answer: (
    <>
      <Timeline
        variant="numbered"
        items={[
          'Toca "Reservar" y elige tu fecha de entrega',
          'Copia el mensaje y envíalo a tu grupo de WhatsApp de viajero de Guvery',
          'Espera nuestra confirmación en el grupo',
          'Con la confirmación, cómpralo y envía el pantallazo por el grupo',
          'Te lo asignamos y lo verás en Mis acuerdos',
        ]}
      />
      <p>
        <small>
          Reservar te da el turno: nadie más puede tomarlo. No lo compres hasta que te confirmemos
          por el grupo; tienes 30 minutos para coordinar con nosotros.
        </small>
      </p>
    </>
  ),
};



interface OrdersInfoPanelProps {
  view: 'all' | 'match';
}

/**
 * Ayuda de Pedidos en un solo drawer. El panel abre con la primera pregunta expandida:
 * en la pestaña Match va primero lo de Match, en Todos lo de ofertar.
 */
const OrdersInfoPanel = ({ view }: OrdersInfoPanelProps) => {
  const faqs =
    view === 'match'
      ? [matchFaq, reserveFaq, offerFaq, nationalFaq]
      : [offerFaq, nationalFaq, matchFaq, reserveFaq];

  return (
    <FAQPanel
      faqs={faqs}
      subtitle="Pedidos"
      teaserText="Cómo ofertar, Pedidos Match y Envío Nacional."
    />
  );
};

export default OrdersInfoPanel;
